import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../assets/jss/customStyle";
import $ from "jquery";
import axios from "axios";
import API from "../../../_helpers/endpointService";
import shipImg from "../../../assets/img/ship_img.png";
import {
    Chart as ChartJS,
    CategoryScale,
    ArcElement,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    ArcElement,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels,
);

const observationBC = [
    '#ff6384',
    '#36a2eb',
    '#4bc0c0',
    '#d3d3d3',
];
const tonageColor = [
    '#1C4E80',
    '#1A9CD9',
];//Dark blue , Light blue
const dismantledColor = [
    '#1A9CD9',
];//Light blue
const PFandDMSColor = [
    '#1A9CD9',
    '#1C4E80',
];//Light blue , dark blue
const TotalMan = [
    '#1C4E80',
];//dark blue
const StatusOfColor = [
    '#0FE6EB',
    '#1A9CD9',
    '#1C4E80',
];//Light light blue,Light blue , dark blue
const recorderdataandInvestColor = [
    '#1C4E80',
    '#1A9CD9',
    '#0FE6EB',
];//dark blue,Light blue,Light light blue,
const backgroundColor = [
    '#E5FBF9',
    '#1A9CD9',
    '#0FE6EB',
    '#1C4E80',
]; //
const ghgrecorderdataColor = [
    '#1C4E80',
    '#1A9CD9',
    '#0FE6EB',
    '#d3d3d3',
];//dark blue,Light blue,Light light blue,

var matrixValue = [{ value: 0, percentage: 0 }, { value: 0, percentage: 0 }, { value: 0, percentage: 0 }, { value: 0, percentage: 0 }];
var DismantledPercent = 0;

const observationOption = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
            align: "center",
            position: 'right',
            labels: {
                boxWidth: 10,
                padding: 20,
            }
        },
        datalabels: {
            color: 'black',
            display: true,
            formatter: (value, ctx) => {
                if (value && value !== 0)
                    return value ;
                return null;
            }
        },
    },
}

const noghgEmissionOption = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
            align: "center",
            position: window.innerWidth < 450 || (window.innerWidth < 1100 && window.innerWidth > 1010) ? 'bottom' : 'right',
            labels: {
                boxWidth: 10,
                padding: 20,
            }
        },
        datalabels: {
            display: false,
            //font: {
            //    size: 14,
            //}
        },
    },
}

const ghgRecyclingOption = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
            onClick: null,
            align: "center",
            position: window.innerWidth < 450 || (window.innerWidth < 1100 && window.innerWidth > 1010) ? 'bottom' : 'right',
            labels: {
                boxWidth: 10,
                padding: 20,
            }
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 10
            },
            formatter: (value, ctx) => {
                let total = ctx.dataset.data[0] + ctx.dataset.data[1] + ctx.dataset.data[2]
                if (value && value !== 0) {
                    let total1 = (ctx.dataset.data[0] / total)*100;
                    let total2 = (ctx.dataset.data[1] / total)*100;
                    let total3 = (ctx.dataset.data[2] / total)*100;
                    if(ctx.dataIndex == 1) {
                        if(total2 > 20){
                            return "" +  "\n\n\nScope 2 : " + ((value / total) * 100).toFixed(2) + "% \n" + value.toFixed(2) +"tCO2e";
                        } else {
                            return "" +  "\n\n\n\nScope 2 : " + ((value / total) * 100).toFixed(2) + "% \n" + value.toFixed(2) +"tCO2e";
                        }
                    } else if (ctx.dataIndex == 0 || ctx.dataIndex == 2) {
                        if(ctx.dataIndex == 0) {
                            if (total1 < 20 && total2 < 20){
                                return `Scope ${ctx.dataIndex + 1} : ` +  ((value / total) * 100).toFixed(2) + "% \n" + value.toFixed(2) + "tCO2e";
                            } else if (total1 < 20 && total3 < 20){
                                return `\n\n\n\n\nScope ${ctx.dataIndex + 1} : ` +  ((value / total) * 100).toFixed(2) + "% \n" + value.toFixed(2) + "tCO2e";
                            } else {
                                    return `\nScope ${ctx.dataIndex + 1} : ` +  ((value / total) * 100).toFixed(2) + "% \n" + value.toFixed(2) + "tCO2e";
                            }
                        } else {
                            if(total3 > 20){
                                return `   \n\n\n\n\nScope ${ctx.dataIndex + 1} : ` +  ((value / total) * 100).toFixed(2) + "% \n" + value.toFixed(2) + "tCO2e";
                            } else {
                                return `Scope ${ctx.dataIndex + 1} : ` +  ((value / total) * 100).toFixed(2) + "% \n" + value.toFixed(2) + "tCO2e";
                            }
                        }
                    } else {
                        return null;
                    }
                }  else {
                    return null;
                }
            }
        },
    },
}

const noobservationOption = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
            align: "center",
            position: 'right',
            labels: {
                boxWidth: 10,
                padding: 20,
            }
        },
        datalabels: {
            display: false,
            //font: {
            //    size: 14,
            //}
        },
    },
}

const Tonnageoptions = {
    responsive: true,
    plugins: {
        legend: {
            position: 'bottom',
            display: false,
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 12,
            },
            formatter: (value, ctx) => {
                return value ? value + " T" : 0 + " T";
            },
        },
    },
    animation: {
        duration: 0
    },
    elements: {
        line: {
            fill: false
        },
        point: {
            hoverRadius: 7,
            radius: 5
        }
    },
    scales: {
        x: {
            stacked: false,
            grid: {
                display: false,
                drawBorder: false,
            },
            ticks: {
                color: "black",
                font: {
                    size: 12,
                    lineHeight: 1.5,
                },
            }
        },
        y: {
            stacked: false,
            grace: "60%",
            grid: {
                display: false,
                drawBorder: false,
            },
            ticks: {
                display: false,
                color: "black",
            }
        }
    }
};

const ManPoweroptions = {
    responsive: true,
    plugins: {
        legend: {
            position: 'bottom',
            display: false,
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 12,
            },
            formatter: (value, ctx) => {
                return value ? value : 0;
            },
        },
    },
    animation: {
        duration: 0
    },
    scales: {
        x: {
            stacked: false,
            grid: {
                display: false,
                drawBorder: false,
            },
            ticks: {
                color: "black",
                font: {
                    size: 12,
                    lineHeight: 1.5,
                },
            }
        },
        y: {
            stacked: false,
            grace: "60%",
            grid: {
                display: false,
                drawBorder: false,
            },
            ticks: {
                display: false,
                color: "black",
            }
        }
    }
};

const Investigationoptions = {
    responsive: true,
    plugins: {
        legend: {
            position: 'bottom',
            display: false,
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 12,
            },
            formatter: (value, ctx) => {
                return value ? value : 0;
            }

        },
    },
    animation: {
        duration: 0
    },
    scales: {
        x: {
            stacked: true,
            grid: {
                display: false,
                drawBorder: false,
            },
            ticks: {
                color: "black",
                font: {
                    size: 12,
                },
            }
        },
        y: {
            stacked: false,
            grace: "60%",
            grid: {
                display: false,
                drawBorder: false,
            },
            ticks: {
                display: false,
                color: "black",
            }
        }
    }
};

const ProjectFlowoptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: {
            position: 'right',
            display: false,
        },
        datalabels: {
            align: 'end',
            color: 'black',
            display: true,
            font: {
                size: 12,
            },
            formatter: (value, ctx) => {
                return value ? value : 0;
            },
            offset: function (context) {
                if (!context.dataset.data[context.dataIndex] || context.dataset.data[context.dataIndex] === 0) {
                    return 0;
                }
                else {
                    return 0;
                }
            },
        },
    },
    scales: {
        x: {
            stacked: false,
            grace: "60%",
            ticks: {
                display: false,
                color: "black",
            }
        },
        y: {
            stacked: false,
            ticks: {
                color: "black",
                font: {
                    size: 12,
                    lineHeight: 1.8,
                },
            }
        }
    }
};

const Dismantledoptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: {
            position: 'right',
            display: false,
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 12,
            },
            formatter: (value, ctx) => {
                return value ? value.toString().includes('.') ? value.toFixed(2) + '%' : value + '%' : 0 + '%';
            },
            offset: function (context) {
                if (!context.dataset.data[context.dataIndex] || context.dataset.data[context.dataIndex] === 0) {
                    return -30;
                }
                else {
                    return 0;
                }
            },
        },
    },
    scales: {
        x: {
            stacked: false,
            ticks: {
                display: false,
                color: "black",
            }
        },
        y: {
            stacked: false,
            barPercentage: 0.4,
            ticks: {
                color: "black",
                font: {
                    size: 12,
                },
            }
        }
    }
};


const ghgEmissionOptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: {
            position: 'right',
            display: false,
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 12
            },
            formatter: (value, ctx) => {
                if(ctx.dataIndex == 0){
                    return value ?  ctx.dataset.data[3] + "% of \n Emissions saved" : 0;
                } else if (ctx.dataIndex == 1 || ctx.dataIndex == 2) {
                    return value ?  value + " tCO2e" : 0;
                } else {
                    return "";
                }
            }
        },
    },
    scales: {
        x: {
            stacked: false,
            grace: "250%",
            ticks: {
                display: false,
                color: "black",
            }
        },
        y: {
            stacked: false,
            ticks: {
                color: "black",
                font: {
                    size: 12,
                    lineHeight: 1,
                },
            }
        }
    }
};

const Complanceoptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: {
            position: 'right',
            display: false,
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 12
            },
            formatter: (value, ctx) => {
                return value ? value : 0;
            }
        },
    },
    scales: {
        x: {
            stacked: false,
            grace: "60%",
            ticks: {
                display: false,
                color: "black",
            }
        },
        y: {
            stacked: false,
            ticks: {
                color: "black",
                font: {
                    size: 12,
                    lineHeight: 1.8,
                },
            }
        }
    }
};

const RecordedInvestigtionOptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: {
            position: 'right',
            display: false,
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 12
            },
            formatter: (value, ctx) => {
                return value ? value : 0;
            }
        },
    },
    scales: {
        x: {
            stacked: false,
            grace: "60%",
            ticks: {
                display: false,
                color: "black",
            }
        },
        y: {
            stacked: false,
            ticks: {
                color: "black",
                font: {
                    size: 12,
                    lineHeight: 1.5,
                },
            }
        }
    }
};

const Matrixoptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: {
            position: 'right',
            display: false,
        },
        datalabels: {
            color: 'black',
            display: true,
            font: {
                size: 12,
            },
            formatter: (value, ctx) => {
                return value ? value : 0;
            },
            offset: function (context) {
                if (context.dataset.data[context.dataIndex] <= 300) {
                    return -30;
                }
            },
        },
    },
    scales: {
        x: {
            stacked: false,
            grace: "70%",
            ticks: {
                display: false,
                color: "black",
            }
        },
        y: {
            stacked: false,
            ticks: {
                color: "black",
                font: {
                    size: 12,
                },
            }
        }
    }
};

const MatrixData = {
    labels: ['Landfill   ', 'Recycled   ', 'Reused   ', 'Lightship   '],
    datasets: [
        {
            data: [0, 0, 0, 0],
            backgroundColor: backgroundColor,
            datalabels: {
                labels: {
                    index: {
                        align: 'end',
                        anchor: 'end',
                        formatter: function (value, ctx) {
                            return (matrixValue[ctx.dataIndex].percentage) + "%";
                        },
                        offset: function (context) {
                            // if (!matrixValue[context.dataIndex].percentage || matrixValue[context.dataIndex].percentage <= 20) {
                            //     return 20;
                            // }
                            const arr = context.dataset.data;
                            const max = Math.max(...arr);
                            const indexmax = arr.indexOf(max);
                            const min = Math.min(...arr);
                            const indexmin = arr.indexOf(min);
                            if (context.dataIndex == indexmin) {
                                return 55;
                            }
                            if (context.dataIndex != indexmax) {
                                return 55;
                            }
                            if (context.dataIndex == indexmax) {
                                return 30;
                            }
                        },
                    },
                    value: {
                        align: 'start',
                        anchor: 'end',
                        formatter: function (value, ctx) {
                            return (matrixValue[ctx.dataIndex].value);
                        },
                        offset: function (context) {
                            const arr = context.dataset.data;
                            const max = Math.max(...arr);
                            const indexmax = arr.indexOf(max);
                            const min = Math.min(...arr);
                            const indexmin = arr.indexOf(min);
                            if (context.dataIndex == indexmin) {
                                return -55;
                            }
                            if (context.dataIndex != indexmax) {
                                return -55;
                            }
                            if (context.dataIndex == indexmax) {
                                return -30;
                            }


                            // if (!matrixValue[context.dataIndex].percentage || matrixValue[context.dataIndex].percentage <= 20) {
                            //     return -30;
                            // }
                        },
                        padding: 4
                    }
                }
            },
        },
    ],

};

const PFCompletionData = {
    labels: [['Actual', 'completion'], ['Estimated', 'completion']],
    datasets: [
        {
            data: [0, 0],
            backgroundColor: PFandDMSColor,
            datalabels: {
                align: 'end',
                anchor: 'end',
            },
        },
    ],
};

const ManPowerCompletionData = {
    labels: ['Total manhours'],
    datasets: [
        {
            data: [0],
            backgroundColor: TotalMan,
            datalabels: {
                align: "end",
                anchor: "end",
                font: {
                    size: 13
                }
            },
            barPercentage: 0.5,
        },
    ],
};

const recorderdata = {
    labels: ['Total', 'Closed', 'Open'],
    datasets: [
        {
            data: [0, 0, 0],
            backgroundColor: recorderdataandInvestColor,
            borderColor: recorderdataandInvestColor,
            borderWidth: 1,
        },
    ],
};

const ghgrecorderdata = {
    labels: ['Scope 1', 'Scope 2', 'Scope 3'],
    datasets: [
        {
            data: [0, 0, 0],
            backgroundColor: ghgrecorderdataColor,
            borderColor: ghgrecorderdataColor,
            borderWidth: 0,
        },
    ],
};

const norecordeddata = {
    labels: ['Total', 'Closed', 'Open', ['No recorded', 'observation']],
    datasets: [
        {
            data: [0, 0, 0, 100],
            backgroundColor: observationBC,
            borderColor: observationBC,
            borderWidth: 1,
        },
    ],
};

const noghgrecorderdata = {
    labels: ['No record'],
    datasets: [
        {
            data: [100],
            backgroundColor: ghgrecorderdataColor[3],
            borderColor: ghgrecorderdataColor[3],
            borderWidth: 0,
            // hoverBorderWidth: 0,
        },
    ],
};

const tonnageData = {
    labels: ['Light ship tonnage', 'Dismantled tonnage'],
    datasets: [
        {
            data: [0, 0],
            backgroundColor: tonageColor,
            datalabels: {
                align: "end",
                anchor: "end",
            },
        },
    ],
};

const ProjectFlowData = {
    labels: [['Dismantled', 'status'], ['Estimated', 'completion']],
    datasets: [
        {
            data: [0, 0],
            backgroundColor: PFandDMSColor,
            datalabels: {
                labels: {
                    index: {
                        align: 'end',
                        anchor: 'end',
                        formatter: function (value, ctx) {
                            if (ctx.dataIndex == 0) {
                                return DismantledPercent + "%";
                            }
                        },
                    },
                }
            },
        },
    ],
};

const DismantledData = {
    labels: ['Dismantled %'],
    datasets: [
        {
            data: [0],
            backgroundColor: dismantledColor,
            datalabels: {
                align: 'start',
                anchor: 'end',
            },
            barPercentage: 0.4,
        },
    ],
};

const ManPowerData = {
    labels: ['Manhour week # 0', 'Total manhours'],
    datasets: [
        {
            data: [0, 0],
            backgroundColor: PFandDMSColor,
            datalabels: {
                align: "end",
                anchor: "end",
                //font: {
                //    size: 13
                //}
            }
        },
    ],
};

const ComplainceData = {
    labels: ['Findings open', 'Findings closed', ['Total no. of findings ', 'during initial audit']],
    datasets: [
        {
            data: [0, 0, 0],
            backgroundColor: StatusOfColor,
            datalabels: {
                align: "end",
                anchor: "end",
            }
        },
    ],
};

const recordedIvestigationData = {
    labels: ['Observations - Closed', 'Observations - Open', 'Total No. of Observations', 'Number of Near Miss', 'Number of Incident', ['Total No. of', 'Investigations'] ],
    datasets: [
        {
            data: [0, 0, 0, 0, 0, 0],
            backgroundColor: StatusOfColor,
            datalabels: {
                align: "end",
                anchor: "end",
            }
        },
    ],
};

const ghgEmissionData = {
    labels: [['% GHG Emission Reduction','from Recycling Process'], ['Total GHG Emissions', 'During Recycling of Steel', 'and Other Components'], ['Estimated GHG Emissions', 'During New Production of', 'Steel and Other Components']],
    datasets: [
        {
            data: [0, 0, 0],
            backgroundColor: StatusOfColor,
            datalabels: {
                align: "end",
                anchor: "end",
            }
        },
    ],
};

const InvestigationData = {
    labels: ['Total', 'Near miss', 'Incident'],
    datasets: [
        {
            data: [0, 0, 0],
            backgroundColor: recorderdataandInvestColor,
            datalabels: {
                align: "end",
                anchor: "end",
            }
        },
    ],
};

class GraphicalDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId: 0,
            isMobile: false,
            isMobile1: false,
            isMobile900: false,
            isEdit: false,
            menu: true,
            dashboarddata: "",
            dashboardStatus: "inprogress"
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        if (window.innerWidth < 1010) {
            this.setState({
                isMobile1: true
            })
        }
        else {
            this.setState({
                isMobile1: false
            })
        }

        if (window.innerWidth < 900) {
            this.setState({
                isMobile900: true
            })
        }
        else {
            this.setState({
                isMobile900: false
            })
        }
        if(window.innerWidth < 450 || (window.innerWidth < 1100 && window.innerWidth > 1010)) {
            ghgRecyclingOption.plugins.legend.position = "bottom"
            noghgEmissionOption.plugins.legend.position = "bottom"
        } else {
            ghgRecyclingOption.plugins.legend.position = "right"
            noghgEmissionOption.plugins.legend.position = "right"
        }

        if(window.innerWidth > 1670) {
            RecordedInvestigtionOptions.scales.y.ticks.font.lineHeight = 1.5;
        } else if (window.innerWidth > 1150) {
            RecordedInvestigtionOptions.scales.y.ticks.font.lineHeight = 1;
        } else if (window.innerWidth > 400){
            RecordedInvestigtionOptions.scales.y.ticks.font.lineHeight = 0.8;
        } else {
            RecordedInvestigtionOptions.scales.y.ticks.font.size = 6;
            RecordedInvestigtionOptions.plugins.datalabels.font.size = 6;
            RecordedInvestigtionOptions.scales.y.ticks.font.lineHeight = 0.7;
        }

        if(window.innerWidth > 1220){
            ghgEmissionOptions.scales.y.ticks.font.lineHeight = 1.5;
        } else if (window.innerWidth > 900){
            ghgEmissionOptions.scales.y.ticks.font.lineHeight = 1.3;
        }

        var fontSize = 12;
        if ((window.innerWidth >= 992 && window.innerWidth <= 1050) || (window.innerWidth >= 0 && window.innerWidth <= 410)) {
            tonnageData.labels = [['Light ship', 'tonnage'], ['Dismantled', 'tonnage']];
            let mplabel = 'week # ' + (this.state.dashboarddata?.WeekNo ? this.state.dashboarddata?.WeekNo.toString() : (0).toString());
            ManPowerData.labels = [['Manhour ', mplabel], ['Total', 'manhours']];
            fontSize = 8;
            //if (this.state.dashboardStatus.toLowerCase() === "completed") {
            //    ManPoweroptions.scales.x.ticks.font.size = 14;
            //    ManPoweroptions.plugins.datalabels.font.size = 14;
            //}
            //else {
            //    ManPoweroptions.scales.x.ticks.font.size = 15;
            //    ManPoweroptions.plugins.datalabels.font.size = 15;
            //    Investigationoptions.scales.x.ticks.font.size = 16;
            //    Investigationoptions.plugins.datalabels.font.size = 16;
            //    Complanceoptions.scales.y.ticks.font.size = 15;
            //    Complanceoptions.plugins.datalabels.font.size = 15;
            //}
            //Tonnageoptions.scales.x.ticks.font.size = 13;
            //Tonnageoptions.plugins.datalabels.font.size = 13;
         if (window.innerWidth < 375){
            ghgEmissionOptions.scales.y.ticks.font.size = 5;
            ghgEmissionOptions.plugins.datalabels.font.size = 5;
        
         } else {
            ghgEmissionOptions.scales.y.ticks.font.size = 8;
            ghgEmissionOptions.plugins.datalabels.font.size = 8;
            RecordedInvestigtionOptions.scales.y.ticks.font.size = 8;
            RecordedInvestigtionOptions.plugins.datalabels.font.size = 8;
         }
     
            ProjectFlowoptions.scales.y.ticks.font.lineHeight = 1.5;
            Complanceoptions.scales.y.ticks.font.lineHeight = 1.5;
       
        }
        else if ((window.innerWidth > 1600) || (window.innerWidth >= 580 && window.innerWidth <= 767)) {
            tonnageData.labels = ['Light ship tonnage', 'Dismantled tonnage'];
            let mplabel = 'Manhour week # ' + (this.state.dashboarddata?.WeekNo ? this.state.dashboarddata?.WeekNo.toString() : (0).toString());
            ManPowerData.labels = [mplabel, 'Total manhours'];
            fontSize = 16;
            //if (this.state.dashboardStatus.toLowerCase() === "completed") {
            //    ManPoweroptions.scales.x.ticks.font.size = 13;
            //    ManPoweroptions.plugins.datalabels.font.size = 13;
            //}
            //else {
            //    ManPoweroptions.scales.x.ticks.font.size = 15;
            //    ManPoweroptions.plugins.datalabels.font.size = 15;
            //    Investigationoptions.scales.x.ticks.font.size = 16;
            //    Investigationoptions.plugins.datalabels.font.size = 16;
            //    Complanceoptions.scales.y.ticks.font.size = 15;
            //    Complanceoptions.plugins.datalabels.font.size = 15;
            //}

        
            ProjectFlowoptions.scales.y.ticks.font.lineHeight = 1.8;
            Complanceoptions.scales.y.ticks.font.lineHeight = 1.8;
            RecordedInvestigtionOptions.scales.y.ticks.font.size = 12;
            RecordedInvestigtionOptions.plugins.datalabels.font.size = 12;
            //Tonnageoptions.scales.x.ticks.font.size = 13;
            //Tonnageoptions.plugins.datalabels.font.size = 13;
        }
        else {
            tonnageData.labels = ['Light ship tonnage', 'Dismantled tonnage'];
            let mplabel = 'Manhour week # ' + (this.state.dashboarddata?.WeekNo ? this.state.dashboarddata?.WeekNo.toString() : (0).toString());
            ManPowerData.labels = [mplabel, 'Total manhours'];
            fontSize = 12;
            //if (this.state.dashboardStatus.toLowerCase() === "completed") {
            //    ManPoweroptions.scales.x.ticks.font.size = 13;
            //    ManPoweroptions.plugins.datalabels.font.size = 13;
            //}
            //else {
            //    ManPoweroptions.scales.x.ticks.font.size = 15;
            //    ManPoweroptions.plugins.datalabels.font.size = 15;
            //    Investigationoptions.scales.x.ticks.font.size = 16;
            //    Investigationoptions.plugins.datalabels.font.size = 16;
            //    Complanceoptions.scales.y.ticks.font.size = 15;
            //    Complanceoptions.plugins.datalabels.font.size = 15;
            //}
            //Tonnageoptions.scales.x.ticks.font.size = 13;
            //Tonnageoptions.plugins.datalabels.font.size = 13;
            if (window.innerWidth < 900 && window.innerWidth > 780 ) {
                ghgEmissionOptions.scales.y.ticks.font.size = 9;
                RecordedInvestigtionOptions.scales.y.ticks.font.size = 12;
                ghgEmissionOptions.plugins.datalabels.font.size = 9;
                RecordedInvestigtionOptions.plugins.datalabels.font.size = 12;
            } else {
                ghgEmissionOptions.scales.y.ticks.font.size = 9;
                RecordedInvestigtionOptions.scales.y.ticks.font.size = 9;
                ghgEmissionOptions.plugins.datalabels.font.size = 9;
                RecordedInvestigtionOptions.plugins.datalabels.font.size = 9;
            }
            ProjectFlowoptions.scales.y.ticks.font.lineHeight = 1.5;
            Complanceoptions.scales.y.ticks.font.lineHeight = 1.5;
           
        }
        Tonnageoptions.scales.x.ticks.font.size = fontSize;
        Tonnageoptions.plugins.datalabels.font.size = fontSize;
        ManPoweroptions.scales.x.ticks.font.size = fontSize;
        ManPoweroptions.plugins.datalabels.font.size = fontSize;
        Investigationoptions.scales.x.ticks.font.size = fontSize;
        Investigationoptions.plugins.datalabels.font.size = fontSize;
        Matrixoptions.scales.y.ticks.font.size = fontSize;
        Matrixoptions.plugins.datalabels.font.size = fontSize;
        Complanceoptions.scales.y.ticks.font.size = fontSize;
        Complanceoptions.plugins.datalabels.font.size = fontSize;
        Dismantledoptions.scales.y.ticks.font.size = fontSize;
        Dismantledoptions.plugins.datalabels.font.size = fontSize;
        ProjectFlowoptions.scales.y.ticks.font.size = fontSize;
        ProjectFlowoptions.plugins.datalabels.font.size = fontSize;
        $("#Dashboard1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dashboard").removeClass("d-none");
        $("#Dashboard").addClass("d-block");
    };

    componentDidMount() {
        var ProjectId = localStorage.getItem("DashId");
        this.state.ProjectId = ProjectId;
        this.setState({});
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
        this.getProjectDashBoard(ProjectId);
    };

    getProjectDashBoard = (id) => {
        let apiUrl = API.DASHBOARD_DETAILS + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true });
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.dashboarddata = response?.data;
                    this.state.dashboardStatus = response?.data?.Status;
                    DismantledPercent = response?.data?.DismantledPercent;
                    MatrixData.datasets[0].data = [
                        this.state.dashboarddata?.ProjectMatrixOfMaterials?.LandFill,
                        this.state.dashboarddata?.ProjectMatrixOfMaterials?.Recycled,
                        this.state.dashboarddata?.ProjectMatrixOfMaterials?.Reused,
                        this.state.dashboarddata?.ProjectMatrixOfMaterials?.LigtShip
                    ]
                    matrixValue = [{ value: this.state.dashboarddata?.ProjectMatrixOfMaterials?.LandFill + "T", percentage: this.state.dashboarddata?.ProjectMatrixOfMaterials?.LandFillPercentage },
                    { value: this.state.dashboarddata?.ProjectMatrixOfMaterials?.Recycled + "T", percentage: this.state.dashboarddata?.ProjectMatrixOfMaterials?.RecycledPercentage },
                    { value: this.state.dashboarddata?.ProjectMatrixOfMaterials?.Reused + "T", percentage: this.state.dashboarddata?.ProjectMatrixOfMaterials?.ReusedPercentage },
                    { value: this.state.dashboarddata?.ProjectMatrixOfMaterials?.LigtShip + "T", percentage: this.state.dashboarddata?.ProjectMatrixOfMaterials?.LigtShipPercentage }];
                    PFCompletionData.datasets[0].data = [
                        this.state.dashboarddata?.NoOfMonthsActual,
                        this.state.dashboarddata?.NoOfMonthsEstimated
                    ]
                    ManPowerCompletionData.datasets[0].data = [
                        this.state.dashboarddata?.TotalManPower
                    ]
                    recorderdata.datasets[0].data = [
                        this.state.dashboarddata?.DailyObservationTotal,
                        this.state.dashboarddata?.DailyObservationClosed,
                        this.state.dashboarddata?.DailyObservationOpened
                    ]
                    InvestigationData.datasets[0].data = [
                        this.state.dashboarddata?.TotalInvestigationRecord,
                        this.state.dashboarddata?.NearMiss,
                        this.state.dashboarddata?.Incident
                    ]
                    ComplainceData.datasets[0].data = [
                        this.state.dashboarddata?.TotalFindingsOpened,
                        this.state.dashboarddata?.TotalFindingsClosed,
                        this.state.dashboarddata?.TotalFindingsIntialAudit
                    ]
                    tonnageData.datasets[0].data = [
                        this.state.dashboarddata?.ShipParticualrsDTO?.LightShipWeight,
                        this.state.dashboarddata?.DismantledTonnage
                    ]
                    ProjectFlowData.datasets[0].data = [
                        this.state.dashboarddata?.NoOfMonthsActual,
                        this.state.dashboarddata?.NoOfMonthsEstimated
                    ]
                    DismantledData.datasets[0].data = [
                        this.state.dashboarddata?.DismantledPercent
                    ]
                    ManPowerData.datasets[0].data = [
                        this.state.dashboarddata?.ManHour,
                        this.state.dashboarddata?.TotalManPower
                    ]

                    ghgrecorderdata.datasets[0].data = [
                        this.state.dashboarddata?.CarbonEmissionFactor?.Scope1Total,
                        this.state.dashboarddata?.CarbonEmissionFactor?.Scope2Total,
                        this.state.dashboarddata?.CarbonEmissionFactor?.Scope3Total,

                    ]

                    ghgEmissionData.datasets[0].data = [
                        (this.state.dashboarddata?.CarbonEmissionFactor?.GHGProductionEmission.toFixed(2) / 100) * this.state.dashboarddata?.CarbonEmissionFactor?.GHGReduction.toFixed(2),
                        this.state.dashboarddata?.CarbonEmissionFactor?.GHGRecyclingEmission.toFixed(2) ,
                        this.state.dashboarddata?.CarbonEmissionFactor?.GHGProductionEmission.toFixed(2) ,
                        this.state.dashboarddata?.CarbonEmissionFactor?.GHGReduction.toFixed(2)
                    ]

                    recordedIvestigationData.datasets[0].data = [
                        this.state.dashboarddata?.DailyObservationClosed,
                        this.state.dashboarddata?.DailyObservationOpened,
                        this.state.dashboarddata?.DailyObservationTotal,
                        this.state.dashboarddata?.NearMiss,
                        this.state.dashboarddata?.Incident,
                        this.state.dashboarddata?.TotalInvestigationRecord,
                    ]

                    var mplabel = 'Manhour week # ' + (this.state.dashboarddata?.WeekNo ? this.state.dashboarddata?.WeekNo.toString() : (0).toString());
                    ManPowerData.labels = [mplabel, 'Total manhours'];
                    this.setState({});
                } else {
                    this.clearData();
                    this.state.dashboarddata = [];
                    this.setState({});
                }
            })
            .catch((error) => {
                this.clearData();
                this.state.dashboarddata = [];
                this.setState({})
                this.props.dispatch({ type: "SHOW_LOADER", data: false });
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    clearData() {
        MatrixData.datasets[0].data = [0, 0, 0, 0];
        matrixValue = [{ value: 0, percentage: 0 }, { value: 0, percentage: 0 }, { value: 0, percentage: 0 }, { value: 0, percentage: 0 }];
        PFCompletionData.datasets[0].data = [0, 0]
        ManPowerCompletionData.datasets[0].data = [0]
        recorderdata.datasets[0].data = [0, 0, 0]
        InvestigationData.datasets[0].data = [0, 0, 0]
        ComplainceData.datasets[0].data = [0, 0, 0]
        tonnageData.datasets[0].data = [0, 0]
        ProjectFlowData.datasets[0].data = [0, 0]
        DismantledData.datasets[0].data = [0]
        ManPowerData.datasets[0].data = [0, 0]
        ghgrecorderdata.datasets[0].data = [0, 0, 0]
        ghgEmissionData.datasets[0].data = [0, 0, 0]
        recordedIvestigationData.datasets[0].data = [0, 0, 0, 0, 0, 0]
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { isMobile, dashboarddata } = this.state;
        return (<>
            <div className="pt-2 ml-auto scroll-hide" style={{ backgroundColor: "#00838F", width: "100%", marginTop: this.state.isMobile ? 64 : -96, borderTop: '1px solid #037984' }}>
                <div className="">
                    <div className="mx-5 mt-1 mb-4 pb-1">
                        <div> <label className="hfontclr">Ship Particulars</label></div>
                        <div className="row mx-0 my-2" >
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bborder">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Name of ship</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.Name}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bborder card-rbr">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Ship type</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.Type}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bborder card-rrbr card-set">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Flag</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.PortOfRegistry}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bborder card-rbr card-br">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Ship owner</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipOwner}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bborder ">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">IMO number</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.IMONumber}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bborder card-rbr card-rrbr">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Length overall</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.Length}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bborder card-btm-unset card-breverse-unset">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Breadth</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.Breath}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bborder card-rbr card-br card-btm-unset card-rb">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Depth</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.Depth}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6 card-bbborder card-bbr card-rrbr card-reverse-rrbr">
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Year of construction</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.ConstructionDate}</span>
                                </div>
                            </div>
                            <div className="align col-lg-1 col-xl-1 col-md-3 col-sm-4 col-6" style={{ borderRight: "unset" }}>
                                <div className="mx-auto ccenter my-3">
                                    <span className="hhfontclr">Classification society</span>
                                    <span className="bfontClr">{this.state.dashboarddata?.ShipParticualrsDTO?.ClassificationSociety}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pb-2" style={{ backgroundColor: "#f0f0f08c" }}>
                <div className="row py-4 margin-align">

                    <div className={`col-12 ${this.state.isMobile1 ? "" : 'd-flex'}`}>
                        <div id="StatusDiv" className={`${this.state.isMobile1 ? "col-12" : "col-lg-8 col-xl-8 col-md-6 width-chart"} card ship-space mb-3  cardalign `} >
                            <span className="bfont">Status</span><br />
                            <span className="text-center">
                                <img src={dashboarddata?.Drawing?.FileUrl} className="img-fluid"></img>
                            </span>
                        </div>
{
    this.state.isMobile1 ? <></> : 
    <div className="col-lg-4 col-md-6 col-xl-4 px-2 col-space">
    <div className="card p-4 mb-3 cardalign">
        {(this.state.dashboardStatus.toLowerCase() == "completed") && this.state.dashboarddata &&
            <>
                <span className="bfont">GHG Emissions during Ship Recycling</span>
                {(this.state.dashboarddata && ((this.state.dashboarddata?.CarbonEmissionFactor?.Scope1 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope1 != 0) || (this.state.dashboarddata?.CarbonEmissionFactor?.Scope2 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope2 != 0) || (this.state.dashboarddata?.CarbonEmissionFactor?.Scope3 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope3 != 0))) ?
                    <Pie data={ghgrecorderdata} options={ghgRecyclingOption} className={`${(window.innerWidth < 1100 && window.innerWidth > 1010) ? "recobs-1" : "recobs hw-graph1"} mt-3 mb-3 `}  />
                    :
                    <Pie data={noghgrecorderdata} options={noobservationOption}  className="recobs mt-3 mb-3 hw-graph1" />
                } </>
        }
        {(this.state.dashboardStatus.toLowerCase() != "completed") && this.state.dashboarddata &&
            <>
                <span className="bfont">Current GHG Emissions during Ship Recycling</span>
                {(this.state.dashboarddata && ((this.state.dashboarddata?.CarbonEmissionFactor?.Scope1 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope1 != 0) || (this.state.dashboarddata?.CarbonEmissionFactor?.Scope2 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope2 != 0) || (this.state.dashboarddata?.CarbonEmissionFactor?.Scope3 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope3 != 0))) ?
                    <Pie data={ghgrecorderdata} options={ghgRecyclingOption} className={`${(window.innerWidth < 1100 && window.innerWidth > 1010) ? "recobs-1" : "recobs hw-graph1"} mt-3 mb-3 `} />
                    :
                    <Pie data={noghgrecorderdata} options={noobservationOption} className="recobs mt-3 mb-3 hw-graph1" />
                } </>
        }

    </div>
</div>
}
                       
                    </div>

{ this.state.isMobile1 == true &&
     <div className={ this.state.isMobile900 ? "col-12 col-md-6 py-2" : (this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2")}>
     <div className="card mr-4 p-4 mb-3 cardalign">
         {(this.state.dashboardStatus.toLowerCase() == "completed") && this.state.dashboarddata &&
             <>
                 <span className="bfont">GHG Emissions during Ship Recycling</span>
                 {(this.state.dashboarddata && ((this.state.dashboarddata?.CarbonEmissionFactor?.Scope1 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope1 != 0) || (this.state.dashboarddata?.CarbonEmissionFactor?.Scope2 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope2 != 0) || (this.state.dashboarddata?.CarbonEmissionFactor?.Scope3 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope3 != 0))) ?
                     <Pie data={ghgrecorderdata} options={ghgRecyclingOption} className={`${window.innerWidth > 400 ? (window.innerWidth < 1100 && window.innerWidth > 1010) ? "recobs-1" : "recobs" : "pieChartWidth"} mt-3 mb-3 hw-graph`}  />
                     :
                     <Pie data={noghgrecorderdata} options={noghgEmissionOption} className={`${window.innerWidth > 400 ? (window.innerWidth < 1100 && window.innerWidth > 1010) ? "recobs-1" : "recobs" : "pieChartWidth"} mt-3 mb-3 hw-graph`}  />
                 } </>
         }
         {(this.state.dashboardStatus.toLowerCase() != "completed") && this.state.dashboarddata &&
             <>
                 <span className="bfont">Current GHG Emissions during Ship Recycling</span>
                 {(this.state.dashboarddata && ((this.state.dashboarddata?.CarbonEmissionFactor?.Scope1 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope1 != 0) || (this.state.dashboarddata?.CarbonEmissionFactor?.Scope2 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope2 != 0) || (this.state.dashboarddata?.CarbonEmissionFactor?.Scope3 && this.state.dashboarddata?.CarbonEmissionFactor?.Scope3 != 0))) ?
                     <Pie data={ghgrecorderdata} options={ghgRecyclingOption} className={`${window.innerWidth > 400 ? (window.innerWidth < 1100 && window.innerWidth > 1010) ? "recobs-1" : "recobs" : "pieChartWidth"} mt-3 mb-3 hw-graph`} />
                     :
                     <Pie data={noghgrecorderdata} options={noghgEmissionOption} className={`${window.innerWidth > 400 ? (window.innerWidth < 1100 && window.innerWidth > 1010) ? "recobs-1" : "recobs" : "pieChartWidth"} mt-3 mb-3 hw-graph`}  />
                 } </>
         }

     </div>
 </div>
}
                    {(this.state.dashboardStatus.toLowerCase() != "completed") &&
                        this.state.dashboarddata &&
                        <div className={ this.state.isMobile900 ? "col-12 col-md-6 py-2" : (this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2")}>
                            <div className="card mr-4 p-4 mb-3 cardalign">
                                <span className="bfont">Tonnage status</span>
                                <Bar options={Tonnageoptions} data={tonnageData} className="mt-3 hw-graph" />
                            </div>
                        </div>
                    }
                    {this.state.dashboardStatus.toLowerCase() == "completed" &&
                        this.state.dashboarddata &&
                        <div className={ this.state.isMobile900 ? "col-12 col-md-6 py-2" : (this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2")}>
                            <div className="card p-4 mb-3 cardalign" >
                                <span className="bfont">Matrix of materials</span>
                                <Bar options={Matrixoptions} data={MatrixData} className="mt-3 hw-graph" />
                            </div>
                        </div>
                    }

                    <div className={ this.state.isMobile900 ? "col-12 col-md-6 py-2" : (this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2")}>
                        <div className="card mr-4 p-4 mb-3 cardalign" >
                            <span className="bfont">Project flow (In Months)</span>
                            {this.state.dashboardStatus.toLowerCase() != "completed" && this.state.dashboarddata ?
                                <Bar options={ProjectFlowoptions} data={ProjectFlowData} className="mt-3 hw-graph" />
                                : this.state.dashboarddata ?
                                    <Bar options={ProjectFlowoptions} data={PFCompletionData} className="mt-3 hw-graph" />
                                    : ""
                            }
                        </div>
                    </div>
                    {
                        (this.state.dashboardStatus.toLowerCase() == "completed" ) &&
                        <div className={ this.state.isMobile900 ? "col-12 col-md-6 py-2" : (this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2")}>
                        <div className={"card mr-4 p-4 cardalign"}>
                            <span className="bfont">GHG Emissions and Reduction data</span>
                            {this.state.dashboarddata &&
                                <Bar options={ghgEmissionOptions} data={ghgEmissionData} className={` ${window.innerWidth > 400 ? 'px-3' : ""} mt-3 mb-3 hw-graph`} />
                            }
                        </div>
                    </div>
                    }
                  
                    {/* {this.state.dashboardStatus.toLowerCase() != "completed" &&
                        this.state.dashboarddata &&
                        <div className="col-lg-4 col-md-6 col-xl-4 px-2 py-2">
                            <div className="card p-4 mb-3 cardalign" >
                                <span className="bfont">Dismantled status</span>
                                <Bar options={Dismantledoptions} data={DismantledData} className="mt-3 hw-graph" />
                            </div>
                        </div>
                    } */}

                    {this.state.dashboardStatus.toLowerCase() != "completed" &&
                        this.state.dashboarddata &&
                        <div className={this.state.isMobile900 ? "col-12 col-md-6 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2"}>
                            <div className="card p-4 mb-3 cardalign" >
                                <span className="bfont">Manpower status</span>
                                <Bar options={ManPoweroptions} data={ManPowerData} className="mt-3 px-3 hw-graph" />
                            </div>
                        </div>
                    }
                    <div className={this.state.dashboardStatus.toLowerCase() == "completed" && this.state.isMobile900 ? "col-12 col-md-6 py-2" : this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2"}>
                        <div className={this.state.dashboardStatus.toLowerCase() == "completed" ? "card mr-4 p-4 cardalign" : "card mr-4 p-4 cardalign"}>
                            <span className="bfont">Status of complaince</span>
                            {this.state.dashboarddata &&
                                <Bar options={Complanceoptions} data={ComplainceData} className="mt-3 mb-3 px-3 hw-graph" />
                            }
                        </div>
                    </div>
                    {(this.state.dashboardStatus.toLowerCase() != "completed") &&
                        <div className={this.state.isMobile900 ? "col-12 col-md-6 py-2" : this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2"}>
                            <div className={this.state.dashboardStatus.toLowerCase() == "completed" ? "card mr-4 p-4 cardalign" : "card mr-4 p-4 cardalign"}>
                                <span className="bfont">Recorded investigations</span>
                                {this.state.dashboarddata &&
                                    <Bar options={Investigationoptions} data={InvestigationData} className="mt-3 mb-3 hw-graph" />
                                }
                            </div>
                        </div>
                    }
                    {
                        (this.state.dashboardStatus.toLowerCase() == "completed") && 
                        <div className={this.state.isMobile900 ? "col-12 col-md-6 py-2" : this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2"}>
                        <div className={`${window.innerWidth > 400 ? "p-4" : ""} card mr-4 cardalign`}>
                            <span className="bfont">Recorded investigations & observations </span>
                            {this.state.dashboarddata &&
                                <Bar options={RecordedInvestigtionOptions} data={recordedIvestigationData} className={` ${window.innerWidth > 400 ? "mt-3 mb-3 px-3" : "p-0"} hw-graph`} />
                            }
                        </div>
                    </div>
                    }
{
    (this.state.dashboardStatus.toLowerCase() != "completed" ) && 
    <div className={this.state.isMobile900 ? "col-12 col-md-6 px-2 py-2" : this.state.dashboarddata ? "col-lg-4 col-xl-4 col-md-6 px-2 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2"}>
    <div className="card p-4 cardalign">
        <span className="bfont"> Recorded observation</span>
        {(this.state.dashboarddata && (this.state.dashboarddata?.DailyObservationTotal && this.state.dashboarddata?.DailyObservationTotal != 0) ||
            (this.state.dashboarddata?.DailyObservationClosed && this.state.dashboarddata?.DailyObservationClosed != 0) ||
            (this.state.dashboarddata?.DailyObservationOpened && this.state.dashboarddata?.DailyObservationOpened != 0)) ?
            <Pie data={recorderdata} options={observationOption} className={`hw-graph recobs-2 mt-3 mb-3 `} />
            :
            <Pie data={norecordeddata} options={noobservationOption} className={`hw-graph recobs-2 mt-3 mb-3 `} />
        }
    </div>
</div>
}
                   
                    {this.state.dashboardStatus.toLowerCase() == "completed" &&
                        this.state.dashboarddata &&
                        <div className={this.state.isMobile900 ? "col-12 col-md-6 py-2" : "col-lg-4 col-md-6 col-xl-4 px-2 py-2"}>
                            <div className="card p-4 mb-3 cardalign" >
                                <span className="bfont">Manpower status</span>
                                <Bar options={ManPoweroptions} data={ManPowerCompletionData} className="mt-5 hw-graph-Totalman" />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>);
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GraphicalDashboard))
);
